import { stringify } from 'qs';
import request from '@/utils/request';

//新增、编辑服务配置
export async function jsch(payload) {
  return request(`/iwms-account/account/jsch`, {
    method: 'POST',
    body: payload
  });
}

//获取应用信息
export async function appinfo(payload) {
  return request(`/iwms-account/account/jsch/appinfo?sshUuid=${payload.sshUuid}`, {
    method: 'GET',
  });
}

//获取磁盘信息
export async function deskinfo(payload) {
  return request(`/iwms-account/account/jsch/deskinfo?sshUuid=${payload.sshUuid}`, {
    method: 'GET',
  });
}

//删除服务器配置
export async function deteleConfig(payload) {
  return request(`/iwms-account/account/jsch/detele?uuid=${payload.uuid}`, {
    method: 'POST',
  });
}

//下载日志
export async function loadLog(payload) {
  return request(`/iwms-account/account/jsch/download/log?fileName=${payload.fileName}&filePath=${payload.filePath}&sshUuid=${payload.sshUuid}`, {
    method: 'GET',
    responseType: 'blob'
  });
}

//获取日志列表
export async function log(payload) {
  return request(`/iwms-account/account/jsch/list/log?filePath=${payload.filePath}&sshUuid=${payload.sshUuid}`, {
    method: 'GET',
  });
}

//获取内存信息
export async function memoryinfo(payload) {
  return request(`/iwms-account/account/jsch/memoryinfo?sshUuid=${payload.sshUuid}`, {
    method: 'GET',
  });
}

//分页查询服务器配置
export async function query(payload) {
  return request(`/iwms-account/account/jsch/query`, {
    method: 'POST',
    body: payload
  });
}

//重启容器
export async function restartDocker(payload) {
  return request(`/iwms-account/account/jsch/restart?dockerId=${payload.dockerId}&sshUuid=${payload.sshUuid}`, {
    method: 'GET',
  });
}

//启动服务
export async function start(payload) {
  return request(`/iwms-account/account/jsch/start?dockerId=${payload.dockerId}&sshUuid=${payload.sshUuid}`, {
    method: 'GET',
  });
}

//停止服务
export async function stop(payload) {
  return request(`/iwms-account/account/jsch/stop?dockerId=${payload.dockerId}&sshUuid=${payload.sshUuid}`, {
    method: 'GET',
  });
}

export async function changeLogLevel(payload) {
  return request(`/iwms-account/account/jsch/changeloglevel?healthPort=${payload.healthPort}&sshUuid=${payload.sshUuid}&packageName=${payload.packageName}&logLevel=${payload.logLevel}`, {
    method: 'GET',
  });
}

export async function restartService(payload) {
  return request(`/iwms-account/account/jsch/restartservice?dockerId=${payload.dockerId}&sshUuid=${payload.sshUuid}&healthPort=${payload.healthPort}`, {
    method: 'GET',
  });
}

export async function genHeapDump(payload) {
  return request(`/iwms-account/account/jsch/genheapdump?sshUuid=${payload.sshUuid}&healthPort=${payload.healthPort}`, {
    method: 'GET',
  });
}

export async function getThreadInfo(payload) {
  return request(`/iwms-account/account/jsch/getthreadinfo?sshUuid=${payload.sshUuid}&healthPort=${payload.healthPort}`, {
    method: 'GET',
  });
}
